import React from "react";
import { useNavigate } from "react-router-dom";
import ManageProjects from "../../pages/common/MangeProject/ManageProjects";

const RoleAwareManageProjects = ({ role }) => {
  const navigate = useNavigate();

  const handleProjectClick = (projectId) => {
    navigate(`/${role}/projects/${projectId}`);
  };

  const handleCreateProject = () => {
    navigate(`/${role}/create-project`);
  };

  return (
    <ManageProjects
      role={role}
      onProjectClick={handleProjectClick}
      onCreateProject={handleCreateProject}
    />
  );
};

export default RoleAwareManageProjects;
